import { render, staticRenderFns } from "./widget-item.vue?vue&type=template&id=80e1a7d4&scoped=true&"
import script from "./widget-item.vue?vue&type=script&lang=js&"
export * from "./widget-item.vue?vue&type=script&lang=js&"
import style0 from "./widget-item.vue?vue&type=style&index=0&id=80e1a7d4&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e1a7d4",
  null
  
)

export default component.exports